<template>
  <div id="app">
    <preloader v-show="preloader_flag"></preloader>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
      preloader_flag: false
    }
  },
  mounted () {
    this.$geb.getFilteredBus({id: 'preloader'}).subscribe(eventData => {
      this.preloader_flag = eventData.eventData
    })
  }
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/App.vue